module.exports = __webpack_public_path__ + "img/pr-16.afa68f55.png";